/**
 * Maps commodity enum keys to human-readable labels.
 * Covers both current CommodityEnum values and legacy reference-data IDs.
 */
export const COMMODITY_LABELS: Record<string, string> = {
  BEE_PRODUCTS: "Bee products",
  DAIRY_AND_DAIRY_PRODUCTS: "Dairy and dairy products",
  DAIRY_PRODUCTS: "Dairy and dairy products",
  FORESTRY: "Forestry",
  LIVE_ANIMALS: "Live animals",
  MEAT_AND_MEAT_PRODUCTS: "Meat and meat products",
  MEAT_PRODUCTS: "Meat and meat products",
  NZ_WINE: "NZ grape wine",
  OTHER_ANIMAL_PRODUCTS: "Other animal products",
  ANIMAL_PRODUCTS: "Other animal products",
  PET_FOOD_AND_ANIMAL_FEED: "Pet food and animal feed",
  ANIMAL_FOOD: "Pet food and animal feed",
  PLANTS_AND_PLANT_PRODUCTS: "Plant and plant products",
  PLANT_PRODUCTS: "Plant and plant products",
  PROCESSED_FOOD_AND_BEVERAGES: "Processed food and beverages",
  PROCESSED_FOOD: "Processed food and beverages",
  SEAFOOD: "Seafood",
}

/**
 * Normalizes a request name by replacing raw commodity enum keys with labels.
 * Extracts the substring between "for " and " to" and checks if it matches a
 * known commodity key, replacing it with the label. Falls back to the provided
 * commodityFallback when the value is missing, undefined, or not a recognized key.
 */
export const normalizeRequestName = (
  requestName: string,
  commodityFallback?: string | null,
): string => {
  if (!requestName) return requestName

  const forIdx = requestName.indexOf("for ")
  const toIdx = requestName.indexOf(" to")

  if (forIdx === -1 || toIdx === -1 || toIdx <= forIdx) return requestName

  const commodity = requestName.substring(forIdx + 4, toIdx).trim()

  let commodityLabel = ""

  if (commodity && commodity !== "undefined" && COMMODITY_LABELS[commodity]) {
    // B2G Requests have trends to receive commodity input like DAIRY_PRODUCTS, this code will update label to Dairy Products
    commodityLabel = COMMODITY_LABELS[commodity]
  } else if (commodityFallback) {
    // Commodity is missing, undefined, or not a known key — use fallback
    commodityLabel = COMMODITY_LABELS[commodityFallback] ?? commodityFallback
  }

  return (
    requestName.substring(0, forIdx + 4) +
    commodityLabel +
    requestName.substring(toIdx)
  )
}
